<template>
  <AttachmentForm :attachments="attachments"></AttachmentForm>
</template>

<script>
import AttachmentForm from './AttachmentForm'
import { mapActions } from 'vuex'

export default {
  name: 'work-request-attachments',
  components: {
    AttachmentForm
  },
  props: {
    equipmentId: String
  },
  mounted() {
    if (this.equipmentId && this.equipmentId.length) {
      if (
        !this.equipmentData ||
        !this.equipmentData.EquipmentId ||
        this.equipmentData.EquipmentId != this.equipmentId
      ) {
        this.updateEquipmentData({ equipmentCode: this.equipmentId }).then(
          () => {
            this.updateEquipmentAttachments({
              equipmentCode: this.equipmentData.EquipmentId,
              modelCode: this.equipmentData.ModelCode
            })
          }
        )
      } else {
        this.updateEquipmentAttachments({
          equipmentCode: this.equipmentId,
          modelCode: this.equipmentData.ModelCode
        })
      }
    }
  },
  computed: {
    attachments() {
      return this.$store.state.equipmentData.attachments
    },
    equipmentData() {
      return this.$store.getters.equipmentData
    }
  },
  methods: {
    ...mapActions(['updateEquipmentAttachments', 'updateEquipmentData'])
  }
}
</script>